import Loading from '@Components/Loading/Loading'
import React from 'react'
import { connect } from 'react-redux'
import Header from '../Header/Header'
import './EducatorLayout.scss'

interface IEducatorLayout {
    children: React.ReactNode
    isLoading?: boolean
}

const EducatorLayout = ({ children, isLoading }: IEducatorLayout) => {
    return (
        <div className="educator-layout">
            <Header />
            <div className="educator-wrapper">
                {/* <div className="educator-content">
                    <Loading isLoading className="position-relative" />
                    {children}
                </div> */}
                <div className="educator-content">
                    <Loading isLoading={isLoading} /> {children}
                </div>
            </div>
        </div>
    )
}

// store section
const mapStateToProps = (state: any) => {
    const isLoading = state?.shared?.loadings?.pageLoading
    return {
        isLoading,
    }
}

export default connect(mapStateToProps, null)(EducatorLayout)
